import { module } from 'angular';
import { publicRoutesConfig } from './public-routing';
import { PublicMobileComponent } from './public.component';
import { GmcFooterMobileComponent, PublicAdditionalModalComponent, PublicHeaderMobileComponent } from './components';
import { AuthModule } from '../auth/auth.module';

export const PublicModule = module('app.mobile.state.public', [
  AuthModule.name
])
  .component('publicMobile', PublicMobileComponent)
  .component('publicHeaderMobile', PublicHeaderMobileComponent)
  .component('gmcFooterMobile', GmcFooterMobileComponent)
  .component('publicAdditionalModal', PublicAdditionalModalComponent)
  .config(publicRoutesConfig);



// WEBPACK FOOTER //
// ./app/states_mobile/public/public.module.ts